import {Component} from '@angular/core';
import {injectModalData, injectModalRef} from '@icz/angular-modal';
import {ReclassifyResultDto} from '|api/codebook';
import {AlertComponent, ButtonComponent, FormButtonsComponent, IconComponent} from '@icz/angular-essentials';
import {EntityType} from '|api/commons';
import {WITHOUT_REF_NUMBER} from '|shared';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'icz-entity-class-reclassification-result-dialog',
  templateUrl: './entity-class-reclassification-result-dialog.component.html',
  styleUrls: ['./entity-class-reclassification-result-dialog.component.scss'],
  imports: [
    AlertComponent,
    IconComponent,
    TranslatePipe,
    ButtonComponent,
    FormButtonsComponent,
  ]
})
export class EntityClassReclassificationResultDialogComponent {
  private modalRef = injectModalRef<Nullable<boolean>>();
  protected dialogData = injectModalData<ReclassifyResultDto>();

  entityIcon(entityType: EntityType) {
    if ([EntityType.DOCUMENT, EntityType.OWN_DOCUMENT].includes(entityType)) {
      return 'big_own_document';
    } else if (EntityType.RECEIVED_DOCUMENT === entityType) {
      return 'big_received_document';
    } else if (EntityType.FILE === entityType) {
      return 'big_file';
    } else {
      return '';
    }
  }

  close() {
    this.modalRef.close(true);
  }

  protected readonly WITHOUT_REF_NUMBER = WITHOUT_REF_NUMBER;
}
